/* Common Imports */
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import CloseIcon from "@material-ui/icons/Close";
import React, { useRef } from "react";

/* Component Imports */

import { Typography } from "@material-ui/core";

/* Data Imports */

import AppConfig from "../../../AppConfig";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    padding: "3rem 8rem 3rem 8rem",
    [theme.breakpoints.down("sm")]: {
      padding: "0rem 1rem 0rem 1rem",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "0rem 1rem 0rem 1rem",
    },
    // [theme.breakpoints.down("md")]: {
    //   width: "100%",
    //   padding: "0rem 2rem 0rem 2rem",
    // },
  },
  megaContainer: {
    width: "100%",
    /* XXS breakpoint */
    [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
      padding: "0rem 0.5rem 0rem 0.5rem",
    },
    [theme.breakpoints.only("xs")]: {
      padding: "0rem 1.5rem 0rem 1.5rem",
    },
    [theme.breakpoints.only("sm")]: {
      padding: "0rem 3rem 0rem 3rem",
    },
    [theme.breakpoints.only("md")]: {
      padding: "0rem 4rem 0rem 4rem",
    },
    [theme.breakpoints.only("lg")]: {
      padding: "0rem 4rem 2rem 4rem",
    },
    /* XLG breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.lg + 48)]: {
      padding: "0rem 5rem 3rem 5rem",
    },
    /* Full HD breakpoint */
    [theme.breakpoints.up("xl")]: {
      padding: "0rem 23rem 3rem 23rem",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      padding: "0rem 36rem 3rem 36rem",
    },
    /* XXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 1920)]: {
      padding: "0rem 72rem 3rem 72rem",
    },
    margin: "4rem 0rem 6rem 0rem",
    [theme.breakpoints.down("sm")]: {
      margin: "3rem 0rem 3rem 0rem",
    },
  },
  sectionContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    gap: "1rem",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      width: "100%",
      margin: "2.5rem 0rem 2.5rem 0rem",
    },
  },
  heading: {
    width: "100%",
    color: "#B56F79",
    fontWeight: 600,
    fontSize: "2.125rem",
    lineHeight: "2.65rem",
    margin: "0rem 0rem 0.5rem 0rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.25rem",
      lineHeight: "2rem",
    },
  },
  subHeading: {
    width: "100%",
    margin: "0rem 0rem 1rem 0rem",
    fontWeight: 400,
    fontSize: "1rem",
    lineHeight: "1.5rem",
    color: "#000000",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem",
      lineHeight: "1.25rem",
      color: "#666666",
    },
  },
  categoryContent: {
    width: "80%",
    minHeight: "150px",
    maxHeight: "400px",
    overflow: "auto",
    transition: "height 0.3s ease",
    background: "#FAFAFA",
    borderRadius: "1rem",
    padding: "1rem 1.5rem 1rem 1.5rem",
    [theme.breakpoints.down("sm")]: {
      display: "none", // Hide on smaller screens
    },
  },
  illustrationSizer: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
    [theme.breakpoints.up("xl")]: { objectFit: "contain", width: "650px", height: "650px" },
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  text: {
    width: "60%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "1rem",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: "0.5rem",
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  timeButtons: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start", // Center-align buttons
    alignItems: "center",
    gap: "0.875rem",
    flexWrap: "wrap", // Allow wrapping to multiple lines
    width: "80%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  timeButton: {
    padding: "0.5rem 1rem",
    fontSize: "0.813rem",
    fontWeight: "500",
    color: "#B56F79",
    background: "#FFFFFF",
    border: "1px solid #B56F79",
    borderRadius: "0.5rem",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  activeTimeButton: {
    background: "#B56F79",
    color: "#FFFFFF",
  },
  ul: {
    fontSize: "1rem",
    paddingLeft: "1rem",
  },
  drawerContent: {
    padding: "1rem",
    [theme.breakpoints.down("sm")]: {
      padding: "1rem",
    },
  },
  drawerHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center", // Align items vertically in the center
    [theme.breakpoints.down("sm")]: {
      color: "#B56F79",
    },
  },
  closeButton: {
    color: "#666666",
  },
  drawerHeading: {
    [theme.breakpoints.down("sm")]: {
      fontSize: "1rem",
      lineHeight: "1.5rem",
      textTransform: "uppercase",
      color: "#B56F79",
    },
  },
  li: {
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem",
      lineHeight: "1.25rem",
      color: "#666666",
    },
  },
}));
const Specifications = (props) => {
  const classes = useStyles();
  const [activeCategory, setActiveCategory] = React.useState("Structure");
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const categoryRefs = useRef({});

  const categoryData = {
    Structure: (
      <ul className={classes.ul}>
        <li className={classes.li}>RCC frame structure with solid block masonry walls </li>
        <li className={classes.li}>Covered car park basement</li>
      </ul>
    ),
    Lift: (
      <ul className={classes.ul}>
        <li className={classes.li}>2 automated high-speed passenger elevators with intercom</li>
        <li className={classes.li}>1 service/stretcher elevator</li>
      </ul>
    ),
    "Landscape & Environment": (
      <ul className={classes.ul}>
        <li className={classes.li}>Extensively landscaped contemporary design of all common open spaces</li>
        <li className={classes.li}>Rainwater harvesting through pits for recharging the ground water table</li>
        <li className={classes.li}>Sewage treatment plant - recycled water to be used for gardening</li>
      </ul>
    ),
    Electrical: (
      <ul className={classes.ul}>
        <li className={classes.li}>Concealed conduit with copper wiring & modular switches</li>
      </ul>
    ),
    Flooring: (
      <ul className={classes.ul}>
        <li className={classes.li}>
          High quality large vitrified tiles flooring and skirting for Foyer, Living, Dining, Kitchen, Family and
          Passage areas
        </li>
        <li className={classes.li}>Superior wooden style vitrified tiles flooring and skirting for Deck & Balcony</li>
      </ul>
    ),
    "Doors & Windows": (
      <ul className={classes.ul}>
        <li className={classes.li}>Apartment main door in teak wood frame & with designer shutter</li>
        <li className={classes.li}>
          Bedroom doors in Mahogany frames and designer shutters Windows: Superior anodized aluminium with glazing
        </li>
      </ul>
    ),
    Painting: (
      <ul className={classes.ul}>
        <li className={classes.li}>Plastic emulsion paint for walls and ceiling</li>
      </ul>
    ),
    "Electricity & Power Backup": (
      <ul className={classes.ul}>
        <li className={classes.li}>BESCOM power </li>
        <li className={classes.li}>100% D.G. power backup for common areas and emergency services</li>
        <li className={classes.li}>Adequate back-up power for each apartment </li>
      </ul>
    ),
    "Water supply": (
      <ul className={classes.ul}>
        <li className={classes.li}>Continuous water supply through borewell</li>
        <li className={classes.li}>Provision for corporation water in kitchen</li>
      </ul>
    ),

    "Safety & Security Systems": (
      <ul className={classes.ul}>
        <li className={classes.li}>Comprehensive ﬁre safety measures as per statutory norms and best standards</li>
        <li className={classes.li}>100% D.G. power backup for common areas and emergency services</li>
        <li className={classes.li}>
          4-tier security system to ensure complete safeguarding at Main entry of the complex, Entrance of Car parking,
          Elevator access and apartment entry
        </li>
      </ul>
    ),
  };
  // Initialize refs for each category
  Object.keys(categoryData).forEach((category) => {
    if (!categoryRefs.current[category]) {
      categoryRefs.current[category] = React.createRef();
    }
  });

  const handleButtonClick = (category) => {
    setActiveCategory(category); // Update the active category
    if (isSmallScreen) {
      // Mobile: Open drawer and scroll to the category
      setDrawerOpen(true);
      setTimeout(() => {
        if (categoryRefs.current[category] && categoryRefs.current[category].current) {
          categoryRefs.current[category].current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 300);
    }
  };

  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  //   const [open, setOpen] = React.useState(false);

  //   const handleOpen = () => {
  //     setOpen(true);
  //   };

  //   const handleClose = () => {
  //     setOpen(false);
  //   };

  return (
    <React.Fragment>
      <div className={classes.mainContainer}>
        <div className={classes.sectionContainer}>
          {/* <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="lg"
            fullWidth
          >
            <DialogContent>
              <img
                src="/images/halcyon-logo/specification.png"
                alt={AppConfig.imageAltText}
                width="100%"
                height="auto"
                loading="lazy"
                referrerPolicy="no-referrer"
              />
            </DialogContent>
          </Dialog> */}
          <div className={classes.text}>
            <Typography
              variant="h1"
              component="h1"
              className={classes.heading}
            >
              Specifications
            </Typography>
            {/* <Typography
              variant="h6"
              component="span"
              className={classes.subHeading}
            >
              The specification and materials used for Heavie Eden have be carefully planned to balance functionality,
              aesthetics and sustainability. We are constantly working on using the best products and incorporating the
              latest construction processes to improve your home experience.
            </Typography> */}
            {/* Buttons for Categories */}
            <div className={classes.timeButtons}>
              {Object.keys(categoryData).map((category) => (
                <button
                  key={category}
                  className={`${classes.timeButton} ${activeCategory === category ? classes.activeTimeButton : ""}`}
                  onClick={() => handleButtonClick(category)}
                >
                  {category}
                </button>
              ))}
            </div>

            {/* Display Data for Active Category */}
            <div className={classes.categoryContent}>
              {typeof categoryData[activeCategory] === "string" ? (
                <Typography
                  variant="body1"
                  component="p"
                >
                  {categoryData[activeCategory]}
                </Typography>
              ) : (
                categoryData[activeCategory]
              )}
            </div>
          </div>
          <img
            src="/images/halcyon-logo/specifications_halcyon.png"
            alt={AppConfig.imageAltText}
            width={512}
            height={512}
            loading="lazy"
            referrerPolicy="no-referrer"
            className={classes.illustrationSizer}
            // onClick={handleOpen} // Open dialog on click
            style={{ cursor: "pointer" }} // Add pointer cursor on hover
          />
        </div>
      </div>
      {/* Bottom Drawer for Mobile */}
      {isSmallScreen && (
        <SwipeableDrawer
          anchor="bottom"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          onOpen={() => setDrawerOpen(true)}
          PaperProps={{
            style: { borderRadius: "1rem 1rem 0rem 0rem", height: "60vh" },
          }}
        >
          <div
            className={classes.drawerContent}
            style={{
              overflowY: "auto",
              height: "100%",
            }}
          >
            {/* Drawer Header */}
            <div
              className={classes.drawerHeader}
              style={{
                position: "sticky",
                top: -16,
                backgroundColor: "#fff",
                zIndex: 10,
                padding: "0.5rem 0rem 0.5rem 0rem",
              }}
            >
              <Typography
                variant="h6"
                component="h2"
                style={{
                  fontWeight: 600,
                  fontSize: "1.25rem",
                  color: "#212121",
                }}
              >
                Specifications
              </Typography>
              <IconButton
                onClick={() => setDrawerOpen(false)}
                className={classes.closeButton}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </div>
            {/* Drawer Content */}
            <div>
              {Object.keys(categoryData).map((category) => (
                <div
                  key={category}
                  ref={categoryRefs.current[category]}
                  style={{ margin: "1rem 0rem 1rem 0rem", zIndex: 0 }}
                >
                  <Typography
                    variant="h6"
                    component="h3"
                    className={classes.drawerHeading}
                  >
                    {category}
                  </Typography>
                  {categoryData[category]}
                </div>
              ))}
            </div>
          </div>
        </SwipeableDrawer>
      )}
    </React.Fragment>
  );
};
export default Specifications;
